import React from 'react';

const s = {
  page: {
    minHeight: '100vh',
    background: 'var(--offwhite)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 24px',
  },
  card: {
    background: '#fff',
    borderRadius: 'var(--radius)',
    boxShadow: 'var(--shadow-lg)',
    maxWidth: '580px',
    width: '100%',
    overflow: 'hidden',
  },
  top: {
    background: 'var(--primary)',
    padding: '32px',
    textAlign: 'center',
  },
  checkCircle: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    background: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
  },
  checkmark: { fontSize: '28px', lineHeight: 1 },
  topTitle: {
    color: '#fff',
    fontFamily: 'var(--font-serif)',
    fontSize: '24px',
    marginBottom: '6px',
  },
  topSub: { color: 'var(--accent)', fontSize: '13px', letterSpacing: '0.06em' },
  accentRule: { height: '3px', background: 'var(--accent)' },
  body: { padding: '32px' },
  dealCard: {
    background: 'var(--stripe)',
    border: '1px solid var(--rule)',
    borderRadius: '8px',
    padding: '18px 20px',
    marginBottom: '24px',
  },
  dealLabel: {
    fontSize: '11px', fontWeight: 700, color: 'var(--mid)',
    letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '6px',
  },
  dealName: {
    fontFamily: 'var(--font-serif)', fontSize: '18px',
    color: 'var(--dark)', marginBottom: '8px',
  },
  dealId: { fontSize: '12px', color: '#8a9ab5', fontFamily: 'monospace' },
  nextStepsTitle: {
    fontSize: '13px', fontWeight: 700, color: 'var(--mid)',
    letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '14px',
  },
  steps: { display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '28px' },
  step: { display: 'flex', alignItems: 'flex-start', gap: '12px', fontSize: '14px', color: 'var(--text)', lineHeight: 1.5 },
  stepNum: {
    background: 'var(--light)', color: 'var(--primary)', borderRadius: '50%',
    width: '22px', height: '22px', display: 'flex', alignItems: 'center',
    justifyContent: 'center', fontSize: '11px', fontWeight: 700, flexShrink: 0, marginTop: '1px',
  },
  btnRow: { display: 'flex', gap: '12px', flexWrap: 'wrap' },
  btnSecondary: {
    flex: 1, minWidth: '160px', padding: '12px 20px',
    background: 'transparent', color: 'var(--primary)',
    border: '1.5px solid var(--rule)', borderRadius: '8px',
    fontSize: '14px', fontWeight: 600, cursor: 'pointer', transition: 'border-color 0.2s',
  },
  footer: { textAlign: 'center', marginTop: '28px', fontSize: '12px', color: '#8a9ab5' },
};

export default function Confirmation({ data, onNew }) {
  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.top}>
          <div style={s.checkCircle}>
            <span style={s.checkmark}>✓</span>
          </div>
          <div style={s.topTitle}>Deal Submitted</div>
          <div style={s.topSub}>Deal record created successfully</div>
        </div>
        <div style={s.accentRule} />
        <div style={s.body}>
          <div style={s.dealCard}>
            <div style={s.dealLabel}>Deal created</div>
            <div style={s.dealName}>{data.dealName || 'New Deal'}</div>
            {data.dealId && <div style={s.dealId}>Deal ID: {data.dealId}</div>}
          </div>
          <div style={s.nextStepsTitle}>Next steps</div>
          <div style={s.steps}>
            {[
              'Upload borrower documents — appraisal, purchase contract, bank statements, entity docs.',
              'Run the AI document review to extract and verify deal details.',
              'Generate the deal summary PDF and send to matched lenders.',
              'Track lender responses in the deal pipeline.',
            ].map((step, i) => (
              <div key={i} style={s.step}>
                <div style={s.stepNum}>{i + 1}</div>
                <span>{step}</span>
              </div>
            ))}
          </div>
          <div style={s.btnRow}>
            <button
              style={s.btnSecondary}
              onClick={onNew}
              onMouseEnter={e => e.target.style.borderColor = 'var(--primary)'}
              onMouseLeave={e => e.target.style.borderColor = 'var(--rule)'}
            >
              Submit another deal
            </button>
          </div>
        </div>
      </div>
      <div style={s.footer}>Crafted Capital Co. · Deal Intake Portal</div>
    </div>
  );
}
